import React from "react";
import { ArrowRight } from "lucide-react";
import { TEMPLATES } from "@/constants/testIds";

const STRATEGY = { external: "Externas (URL)", cid: "CID (embebidas)" };
const FIELDS = [
  { key: "name", label: "Nombre" },
  { key: "category", label: "Categoría" },
  { key: "image_strategy", label: "Imágenes", fmt: (v) => STRATEGY[v || "external"] },
];

export function MetaChanges({ left, right }) {
  const changes = FIELDS
    .map(({ key, label, fmt = (v) => v || "—" }) => ({ key, label, from: fmt(left[key]), to: fmt(right[key]) }))
    .filter((c) => c.from !== c.to);
  const cssChanged = (left.css_content || "") !== (right.css_content || "");
  const htmlChanged = left.html_content !== right.html_content;

  if (!changes.length && !cssChanged && !htmlChanged) {
    return (
      <div className="text-xs text-slate-500 italic" data-testid={TEMPLATES.compareNoChanges}>
        Las dos versiones son idénticas.
      </div>
    );
  }
  return (
    <div className="flex flex-wrap gap-1.5" data-testid={TEMPLATES.compareMetaChanges}>
      {changes.map((c) => (
        <span key={c.key} className="inline-flex items-center gap-1 px-2 py-0.5 rounded border border-orange-200 bg-orange-50 text-[11px] text-slate-700"
          data-testid={`compare-meta-${c.key}`}>
          <strong className="text-slate-900">{c.label}:</strong>
          <span className="line-through text-red-700">{c.from}</span>
          <ArrowRight className="w-3 h-3 text-slate-400" strokeWidth={1.75} />
          <span className="text-emerald-700">{c.to}</span>
        </span>
      ))}
      {htmlChanged && <span className="px-2 py-0.5 rounded border border-slate-200 bg-white text-[11px] text-slate-600">HTML modificado</span>}
      {cssChanged && <span className="px-2 py-0.5 rounded border border-slate-200 bg-white text-[11px] text-slate-600">CSS modificado</span>}
    </div>
  );
}
